"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var WizardParts_1 = require("./WizardParts");
var PREFIX = 'AssignTeamLead';
var classes = {
    leadsHeader: "".concat(PREFIX, "-leadsHeader"),
    input: "".concat(PREFIX, "-input"),
    depts: "".concat(PREFIX, "-depts"),
};
var StyledStepTemplate = (0, styles_1.styled)(WizardParts_1.StepTemplate)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.leadsHeader)] = {
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.input)] = {
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: 10,
            '& input': {
                boxShadow: 'none',
            },
        },
        _b[".".concat(classes.depts)] = {
            fontWeight: theme.typography.fontWeightMedium,
        },
        _b);
});
var AssignAdmin = function (_a) {
    var stepIdx = _a.stepIdx;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var teams = (0, react_final_form_1.useField)('teams', { subscription: { value: true } }).input.value;
    var _b = (0, react_final_form_1.useField)('emails', { subscription: { value: true, error: true } }), emails = _b.input.value, error = _b.meta.error;
    var _c = __read(react_1.default.useState(false), 2), submitting = _c[0], setSubmitting = _c[1];
    var _d = __read((0, hooks_1.useSubmitter)('invitations', null, { companyId: profile.companyId }), 1), invitationSubmitter = _d[0];
    var firestore = (0, react_redux_firebase_1.useFirestore)();
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitting(true);
                    return [4 /*yield*/, Promise.all(teams.map(function (team) { return __awaiter(void 0, void 0, void 0, function () {
                            var adminEmail, teamRef, invRef;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        adminEmail = emails[team.id];
                                        if (error || team.leadEmail === adminEmail)
                                            return [2 /*return*/, null];
                                        teamRef = firestore.collection('company_teams').doc(team.id);
                                        return [4 /*yield*/, invitationSubmitter({
                                                email: adminEmail,
                                                inviterId: profile.id,
                                                companyTeamId: team.id,
                                                targetDocRef: teamRef,
                                                targetField: 'leaderId',
                                                type: 'admin',
                                                accessLevel: interfaces_1.ACCESS_LEVEL.Admin,
                                            })];
                                    case 1:
                                        invRef = _a.sent();
                                        return [2 /*return*/, teamRef.update({ leadInvitationId: invRef.id, leadEmail: emails[team.id] })];
                                }
                            });
                        }); })).catch(function () { return setSubmitting(false); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(StyledStepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: submitting || error }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", width: 470, height: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 4 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "h1" }, { children: [stepIdx + 1, ". Invite team leads"] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.leadsHeader, variant: "body1" }, { children: "Team leads are members of your organisation who are in charge of the various teams you have created. They will be by default assigned ownership of all tools assigned to their team" })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1, flexDirection: "column", width: 1 }, { children: teams === null || teams === void 0 ? void 0 : teams.filter(function (t) { return t.id && !t.leadInvitationId && !t.leaderId; }).map(function (team) { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.depts, variant: "body1" }, { children: team.name })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: "60%" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "emails.".concat(team.id), component: TextField_1.default, color: "secondary", label: "Email", type: "email", autoComplete: "new-password", disabled: submitting, fullWidth: true, helperText: "" }) }))] }), team.id)); }) })) }))] })) })));
};
exports.default = AssignAdmin;
